import React, { Fragment, useMemo } from 'react';
import i18n from '../../../i18n';
import { makeStyles } from '@material-ui/core';

import { Text, TextTypography } from 'components/Text/Text';

const VIDEO_URL = 'https://www.youtube.com/embed/aIHdFlPiIYQ?controls=0';
const EN_VIDEO_URL = 'https://www.youtube.com/embed/gnbpAT1x7AE?controls=0';

const useStyles = makeStyles(theme => ({
    video: {
        border: `8px solid ${theme.palette.fixedPrimary.secondary}`,
        borderRadius: theme.spacing(1.25),
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing(2),
        minHeight: 120,
        minWidth: 160,
        [theme.breakpoints.down(400)]: {
            width: '100%',
        },
    },
}));

interface Props {
    hideDescription?: boolean;
}

export const PromoVideo = ({ hideDescription }: Props) => {
    const {
        t,
        i18n: { language },
    } = i18n.useTranslation();
    const classes = useStyles();
    const videoUrl = useMemo(() => (language === 'ru' ? VIDEO_URL : EN_VIDEO_URL), [language]);
    return (
        <Fragment>
            <iframe
                className={classes.video}
                src={videoUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
            {!hideDescription && <Text typography={TextTypography.BODY}>{t('onboarding:promoVideo.description')}</Text>}
        </Fragment>
    );
};
